import React, { useState } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Config from "../../../Config";
import { Icon } from "../../AuthLayout";
import { isValidEmail, resetPasswordUrl, serverError } from "../../../../utils/password";
import { AccountLayout } from "../shared";


/**
 * /forgot-password — demande du lien de réinitialisation.
 * POST {authURL}/auth/password { email, redirect_url } (devise_token_auth),
 * puis /mail-check/:email. Le lien du mail ramène sur le site en cours.
 */
const ForgotPassword = ({ history }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [attempted, setAttempted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const invalid = !isValidEmail(email);

  const submit = async (event) => {
    event.preventDefault();
    setAttempted(true);
    if (invalid || submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      await Axios.post(
        `${Config.authURL}/auth/password`,
        { email: email.trim(), redirect_url: resetPasswordUrl() },
        Config.headers
      );
      history.push(`/mail-check/${encodeURIComponent(email.trim())}`);
    } catch (err) {
      setError(serverError(err) || t("Server is not responding at the moment, please try later"));
      setSubmitting(false);
    }
  };

  return (
    <AccountLayout t={t}>
      <h1 className="wosh-auth__title">{t("Forgot your password?")}</h1>
      <p className="wosh-auth__lede">{t("Enter your email and we'll send you a link to choose a new one.")}</p>

      {error && <div className="wosh-auth__alert">{error}</div>}

      <form onSubmit={submit} noValidate>
        <label className="wosh-auth__label" htmlFor="forgotEmail">
          {t("Email address")}
        </label>
        <div className={`wosh-auth__field${attempted && invalid ? " wosh-auth__field--invalid" : ""}`}>
          <Icon name="i-mail" />
          <input
            type="email"
            id="forgotEmail"
            autoComplete="email"
            placeholder="camille@exemple.be"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        {attempted && invalid && <p className="wosh-auth__error">{t("Enter a valid email address.")}</p>}

        <button type="submit" className="wosh-auth__cta wosh-acc__cta" disabled={submitting}>
          {submitting && <span className="wosh-auth__spinner" />}
          {submitting ? t("Sending") : t("Send the link")}
        </button>
      </form>

      <p className="wosh-auth__switch">
        {t("Remembered it?")} <Link to="/sign-in">{t("Sign in")}</Link>
      </p>
    </AccountLayout>
  );
};

export default ForgotPassword;
